export const projectData = [
  {
    id: 1,
    title: "MyMedtrace",
    date: "April 2024",
    img: "assets/mymedtrace.png",
    gif: "assets/mymedtrace.gif",
    tools: "React, Solidity, Express.Js, Flask, Ganache, MongoDB",
    description: "MyMedtrace is a blockchain-based Electronic Health Record (EHR) management system with the goal of providing a secure, scalable, and interoperable platform that leverages blockchain for data integrity and smart contracts for privacy and access control. This project is created as my Final Year Project in Nanyang Technological University.",
    web: "https://drive.google.com/file/d/1MniM5DH-T7xsRq7c9SvTQ0bp1RYNpjzm/view?usp=sharing",
    github: "https://github.com/vanessaachristy/FYP-Blockchain-MyMedtrace"
  },
  {
    id: 2,
    title: "Penta",
    date: "Mar 2022",
    img: "assets/penta.png",
    gif: "assets/penta.gif",
    tools: "React",
    description:
      "Penta (Personal Navigator and Travel Assistant), is an intelligent tourism web application that has the ability to assist users to prepare and travel in the new normal. This was created as a part of Hackathon Competition held by EEE Club during EEE Week 2022 and managed to achieve the 2nd Place Winner. Some key features of the application are itinerary planning, personal recommendation, and detection of crowd in the destination. (Only frontend mockup available)",
    web: "https://drive.google.com/file/d/1ZsyfRvvs19aLJRyDyFDJGgsCJawLppaL/view?usp=sharing",
    github: "",
  },
  {
    id: 3,
    title: "SuperGuess",
    date: "Mar 2022",
    img: "assets/superguess.png",
    gif: "assets/superguess.gif",
    tools: "Android Studio, React, MySQL, Java Servlets",
    description:
      "SuperGuess is a live quiz game on a web screen and mobile phone as the player controller. It was built on Android Studio and React for the UI development, and integration of MySQL and Java Servlets for the backend development. It was a part of NTU IM2073: Intro to Design & Project final project.",
    web: "https://drive.google.com/file/d/1F7jI6aJQJ1lVMHU0TWHdTb8v8ijtiGNA/view?usp=sharing",
    github: "",
  },
  {
    id: 4,
    title: "The Abandoned",
    date: "Feb 2022",
    img: "assets/theabandoned.png",
    gif: "assets/theabandoned.gif",
    tools: "Unity3D",
    description:
      "The Abandoned is 3D Escape Room game built on Unity Engine. It comrpises of various interactive riddles located in the items to be solved by the player. Implemented raycast hovering, animation, typewriter effect, and C# scripting during the development process.",
    web: "https://drive.google.com/file/d/1p9M7-8HVHvXaCUQ1WFXf3Ik9jjiIecx-/view?usp=sharing",
    github: "",
  },
  {
    id: 5,
    title: "FitFriend",
    date: "Aug 2021",
    img: "assets/fitfriend.png",
    gif: "assets/fitfriend.gif",
    tools: "Figma",
    description:
      "Fitfriend is an all-in-one platform providing free home workout, training & meal plan packages, blog & forum, and shop. Created the UI/UX design and prototype using Figma.",
    web: "https://www.figma.com/proto/oXycZT74VCsQa2hBbs1OJf/FitFriend-Website?page-id=0%3A1&node-id=1%3A4&viewport=241%2C48%2C0.34&scaling=min-zoom&starting-point-node-id=1%3A4",
    github: "",
  },
  {
    id: 6,
    title: "GTD Unsolved",
    date: "Nov 2021",
    img: "assets/gtdunsolved.png",
    gif: "assets/gtdunsolved.gif",
    tools: "Figma",
    description:
      "GTD Unsolved is a series of mind-bending, story-driven, and character-rich games presented by the Indonesian Freshmen Orientation committee. Created the UI/UX desing and prototype using Figma that showcases all the available games and booking system for the players to purchase.",
    web: "https://www.figma.com/proto/eBzdYEsFYRKE3sTt1MmDn9/Mockup?page-id=0%3A1&node-id=67%3A182&viewport=241%2C48%2C0.12&scaling=min-zoom&starting-point-node-id=102%3A1248&show-proto-sidebar=1",
    github: "",
  },
  {
    id: 7,
    title: "Sudoku Game",
    date: "Mar 2021",
    img: "assets/sudoku.png",
    gif: "assets/sudoku.gif",
    tools: "Java (Java Swing, Abstract Window Toolkit)",
    description:
      "A Sudoku game that was part of NTU IM1003 (Object-Oriented Programming) module project. It was built on Java by utilizing the Java Swing and AWT to build the GUI components. Developed the gameplay using a backtracking algorithm, and implemented 3 difficulty levels with a scoring system, hint, and interactive music.",
    web: "https://drive.google.com/file/d/1VIOAzyx3Xoci08720CvvvCMhOThzksC3/view?usp=sharing",
    github: "https://github.com/vanessaachristy/Sudoku-OOP-",
  },
];
